import { render, staticRenderFns } from "./partner-data.vue?vue&type=template&id=d92d8a82&scoped=true"
import script from "./partner-data.vue?vue&type=script&lang=js"
export * from "./partner-data.vue?vue&type=script&lang=js"
import style0 from "./partner-data.vue?vue&type=style&index=0&id=d92d8a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92d8a82",
  null
  
)

export default component.exports